import { Link } from 'react-router-dom';
import { products } from '@/mocks/products';

const specIcons: Record<string, string> = {
  potencia: 'ri-flashlight-line',
  velocidade: 'ri-speed-line',
  temperatura: 'ri-temp-hot-line',
  material: 'ri-stack-line',
};

const specLabels: Record<string, string> = {
  potencia: 'Potência',
  velocidade: 'Velocidade',
  temperatura: 'Temperatura',
  material: 'Material',
};

export default function MachinesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="mb-10 md:mb-14">
          <span className="text-primary-500 text-xs uppercase tracking-widest mb-2 block">Catálogo Completo</span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 uppercase leading-tight">Nossas Máquinas</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-md">Máquinas de solda geomembrana importadas — cunha quente, extrusoras e acessórios para impermeabilização profissional.</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6" data-product-shop>
          {products.map((product) => (
            <div key={product.id} className="group bg-white rounded-2xl overflow-hidden border border-background-200/70 flex flex-col transition-all duration-300 hover:-translate-y-1 hover:border-primary-300">
              <div className="relative w-full h-48 md:h-52 bg-gradient-to-br from-background-100 to-background-200 flex items-center justify-center p-5">
                {product.badge && (
                  <span className="absolute top-3 left-3 bg-primary-500 text-white text-[10px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wide">{product.badge}</span>
                )}
                <img
                  alt={`${product.name} - ${product.category.toLowerCase()}`}
                  className="h-full w-full object-contain group-hover:scale-105 transition-transform duration-500"
                  src={product.image}
                />
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3 uppercase">{product.name}</h3>
                <div className="grid grid-cols-2 gap-2 mb-4">
                  {Object.entries(product.specs).map(([key, value]) => (
                    <div key={key} className="flex items-center gap-2 bg-background-100 rounded-lg px-3 py-2">
                      <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                        <i className={`${specIcons[key] || 'ri-settings-line'} text-primary-500 text-sm`} />
                      </div>
                      <div className="min-w-0">
                        <p className="text-foreground-900 text-[10px] uppercase tracking-wide leading-none mb-0.5">{specLabels[key] || key}</p>
                        <p className="text-foreground-950 text-xs truncate">{value}</p>
                      </div>
                    </div>
                  ))}
                </div>
                <Link
                  to={`/modelos-de-maquinas/${product.slug}`}
                  className="mt-auto flex items-center justify-center gap-2 border-2 border-primary-500 text-primary-600 hover:bg-primary-500 hover:text-white text-xs md:text-sm px-4 py-2.5 rounded-xl transition-all duration-200 cursor-pointer whitespace-nowrap uppercase tracking-wide font-bold"
                >
                  Ver Informações
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}